import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { CallbackComponent } from './auth/callback.component';
import { authGuard } from './auth/auth.guard';

/**
 * Public deep links kept from the legacy app: /building/{id}, /poi/{id},
 * /functionalarea/{id}, /defect/{id}. Matched case-insensitively, as the
 * ASP.NET routes that used to serve them were.
 */
export function deepLinkMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length !== 2 || !/^(building|poi|functionalarea|defect)$/i.test(segments[0].path)) {
    return null;
  }
  return { consumed: segments, posParams: { type: segments[0], id: segments[1] } };
}

export const routes: Routes = [
  // OIDC callback route - processes the authorization code
  // Must match the redirect URI registered in Keycloak
  {
    path: 'AuthenticationCallback',
    component: CallbackComponent,
  },

  // Site selector - entry screen after authentication
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authGuard],
    loadComponent: () => import('./site-selector/site-selector.component').then((m) => m.SiteSelectorComponent),
  },

  // Map view - main application with IVION viewer
  // Accepts deep link parameters: /map?siteId=...&building=... (see DeepLinkService)
  {
    path: 'map',
    canActivate: [authGuard],
    loadComponent: () => import('./main/main.component').then((m) => m.MainComponent),
  },

  // Deep links - resolve the entity to its site and continue to the map
  {
    matcher: deepLinkMatcher,
    canActivate: [authGuard],
    loadComponent: () => import('./deep-link/deep-link.component').then((m) => m.DeepLinkComponent),
  },

  // Wildcard route - redirect to site selector
  {
    path: '**',
    redirectTo: '',
  },
];
